import { isDate } from 'moment';
import { apiSlice } from '../../../../app/apiSlice';
import { Noticia, NoticiaDTO, NoticiaList, NoticiaListPublicResponse } from '../../../../typesSite/noticia/Noticia';
import configSiteUrls from '../../configs/configSiteUrls';
import { formatDateToISO } from '../../../../utils/formatDate';
//usei o noticia como base

const endpointUrl = configSiteUrls.SITE_NOTICIA_PUBLIC_EP;

interface params {
  data_inicial: string | null;
  data_final: string | null;
  search: string | null;
  page: number | null;
  apply: boolean;
}

function getNoticiasPublic({ data_inicial, data_final, search, page }: params) {
  const queryParams = new URLSearchParams();

  if (search) queryParams.append('search', search);
  if (data_inicial) queryParams.append('dataInicial', formatDateToISO(data_inicial));
  if (data_final) queryParams.append('dataFinal', formatDateToISO(data_final));
  if (page !== null && page !== undefined) queryParams.append('page', page.toString());

  return {
    url: `${endpointUrl}/all?${queryParams.toString()}`, // remove /all se não existir no backend
    method: 'GET'
  };
}

function getUltimasNoticiasPublic() {
  return {
    url: `${endpointUrl}/last`, // remove /all se não existir no backend
    method: 'GET'
  };
}

/** */

export const noticiaPublicApiSlice = apiSlice.injectEndpoints({
  endpoints: ({ query, mutation }) => ({
    getNoticiasPublic: query<NoticiaListPublicResponse, params>({
      //query: (id) => `${endpointUrl}/ciencia/${id}`,
      query: getNoticiasPublic,
      providesTags: ['NoticiaSite']
    }),
    getUltimasNoticiasPublic: query<NoticiaListPublicResponse, void>({
      //query: (id) => `${endpointUrl}/ciencia/${id}`,
      query: getUltimasNoticiasPublic,
      providesTags: ['NoticiaSite']
    })
  })
});
export const { useGetNoticiasPublicQuery, useGetUltimasNoticiasPublicQuery } = noticiaPublicApiSlice;
